import { Button } from "@ameelio/ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FAQListItem } from "../lib/FAQListDialog";

type Props = {
  meetingDurationMins: number;
  meetingId?: string;
};

export default function VideoCallFAQList({
  meetingDurationMins,
  meetingId,
}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const faqItems = [
    {
      question: t("Is my device ready to join the call?"),
      answer: (
        <Button
          variant="outlined"
          onClick={() => {
            navigate("/test-lobby", {
              state: {
                fromPath: `/events/${meetingId}`,
                fromName: t("Event details"),
              },
            });
          }}
        >
          {t("Test sound and video")}
        </Button>
      ),
    },
    {
      question: t("When can I access the call?"),
      answer: t(
        "You may enter the video call Waiting Room up to 5 minutes before your scheduled start time. While you are waiting, you can test the in-call features as well as check your video and audio connection. (We recommend checking your video and audio connection at least once prior to a call.)"
      ),
    },
    {
      question: t("How long is my call?"),
      answer: t(
        "This video call is {{meetingDurationMins}} minutes long, and you may check how much time has elapsed with the in-call clock. When two minutes are remaining, the clock will start counting down. You may leave and rejoin the call anytime within this {{meetingDurationMins}} minute time frame.",
        {
          meetingDurationMins,
        }
      ),
    },
  ];
  return (
    <>
      {faqItems.map((faq) => (
        <FAQListItem key={faq.question} {...faq} />
      ))}
    </>
  );
}
